import { render, staticRenderFns } from "./OlympicsStartModal.vue?vue&type=template&id=10e3d8e6&scoped=true&"
import script from "./OlympicsStartModal.vue?vue&type=script&lang=js&"
export * from "./OlympicsStartModal.vue?vue&type=script&lang=js&"
import style0 from "./OlympicsStartModal.vue?vue&type=style&index=0&id=10e3d8e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e3d8e6",
  null
  
)

export default component.exports